import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import assetInformationChoicesApi from 'config/api/assetInformationChoices/assetInformationChoices';
import QUERY_KEYS from 'config/api/QUERY_KEYS';
import { TableFilterEntity } from 'types/TableFilter';

import { stripLeadingNumber } from '../utils/importanceHelpers';

export type ImportanceOption = { key: string; label: string };

const buildOptionsFromFilters = (list: TableFilterEntity[], t: (key: string | string[]) => string): ImportanceOption[] =>
  list.map(filter => {
    const rawLabel = Array.isArray(filter.name) ? t(filter.name) : filter.name;
    return { key: String(filter.id), label: stripLeadingNumber(rawLabel) };
  });

/**
 * Fetches asset business importance options from API (same source as Assets module)
 * and returns them with labels stripped of leading "N - " prefixes.
 */
export const useImportanceFilterOptions = (): ImportanceOption[] => {
  const { t } = useTranslation();
  const { data: assetImportanceFilters } = useQuery(QUERY_KEYS.ASSETS_INFORMATION_CHOICES, () =>
    assetInformationChoicesApi.getAssetInformationChoicesForFilters(),
  );
  return useMemo(
    () => buildOptionsFromFilters(assetImportanceFilters?.assetsImportance ?? [], t),
    [assetImportanceFilters?.assetsImportance, t],
  );
};
